import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useUser } from '../../contexts/ssr-user-context';
import REGISTER_ACCOUNT_DEVICE from '../../gql/mutations/register-account-device.gql';

const DEVICE_TYPE = '4';
const VERSION_CODE = '22';

function getBrowserName(ua) {
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\/|Opera/.test(ua)) return 'Opera';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Safari\//.test(ua)) return 'Safari';
  return null;
}

function getOsName(ua) {
  if (/Windows/.test(ua)) return 'Windows';
  if (/Android/.test(ua)) return 'Android';
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (/Mac OS X/.test(ua)) return 'macOS';
  if (/Linux/.test(ua)) return 'Linux';
  return null;
}

export default function RegisterDeviceOnLoad() {
  const client = useApolloClient();
  const { user } = useUser();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!user?.id) return;

    const storageKey = `device_fingerprint_${user.id}`;

    (async () => {
      try {
        const ua = navigator.userAgent;

        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const deviceFingerprint = result.visitorId;

        const storedFingerprint = localStorage.getItem(storageKey);
        if (storedFingerprint === deviceFingerprint) return;

        await client.mutate({
          mutation: REGISTER_ACCOUNT_DEVICE,
          variables: {
            registerDevice: {
              deviceFingerprint,
              deviceDetails: {
                browser: getBrowserName(ua),
                os: getOsName(ua),
                model: null,
                deviceType: DEVICE_TYPE,
                versionCode: VERSION_CODE,
              },
            },
          },
        });

        localStorage.setItem(storageKey, deviceFingerprint);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('[RegisterDevice] Failed to register device:', error);
      }
    })();
  }, [client, user]);

  return null;
}
